import { type FC } from 'react'

import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import { Spinner } from 'components/Spinner'
import { useIsPrior2025 } from 'app/KinerjaShared/hooks/useIsPrior2025'

interface DialogDeliveryExecutingProps {
  isOpen: boolean
}

const DialogDeliveryExecuting: FC<DialogDeliveryExecutingProps> = ({
  isOpen = false,
}) => {
  const isPriorTo2025 = useIsPrior2025()

  return (
    <Dialog isOpen={isOpen}>
      <DialogOverlay />
      <DialogContent className="!rounded-lg">
        <div className="px-6 py-20 flex flex-col items-center">
          <Spinner className="!w-28 !h-28 !m-0 !text-base !border-gray-20 !border-l-blue-70" />

          <Text variant="display-sm" className="mt-9 text-center">
            {isPriorTo2025
              ? 'Mengirim ke Pegawai...'
              : 'Mengirim ke Kepala Sekolah...'}
          </Text>
          <Text variant="body-lg" color="subdued" className="mt-1">
            Mohon tunggu sebentar, ya.
          </Text>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default DialogDeliveryExecuting
